import { render } from "./page7.vue?vue&type=template&id=eb05bb70&scoped=true"
import script from "./page7.vue?vue&type=script&lang=js"
export * from "./page7.vue?vue&type=script&lang=js"

import "./page7.vue?vue&type=style&index=0&id=eb05bb70&scoped=true&lang=less"

import exportComponent from "D:\\work\\mvgx-carbon-space-admin-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb05bb70"]])

export default __exports__